
import {
  distanceDisplay
} from '../libs/util';
const defaultImg = require('../assets/images/detail/pic-temp.jpg');
export default {
    methods: {
      processShopData(item, key) {
        let Shop = item.ShopBase;
        let shopimg = '';
        let shopColorName = '';
        let shopUnColorName1 = '';
        let shopUnColorName2 = '';
        if (key && Shop.ShopName.indexOf(key) >= 0) {
          shopColorName = key;
          shopUnColorName1 = Shop.ShopName.substr(0, Shop.ShopName.indexOf(key));
          shopUnColorName2 = Shop.ShopName.substr(Shop.ShopName.indexOf(key) + key.length);
        }
        if (Shop.ShopLogoUrlList.length) {
          shopimg = `${Shop.ShopLogoUrlList[0]}?x-oss-process=image/resize,m_fill,h_120,w_120`;
        } else {
          if (Shop.ShopBannerUrlList.length) {
            shopimg = Shop.ShopBannerUrlList[0];
          }
        }
        if (!shopimg.length) {
          shopimg = defaultImg;
        }
        return {
            ShopSysNo: Shop.ShopSysNo,
            ShopName: Shop.ShopName,
            ShopColorName: shopColorName,
            ShopUnColorName1: shopUnColorName1,
            ShopUnColorName2: shopUnColorName2,
            ShopLogoPathList: Shop.ShopLogoPathList,
            ShopLogoUrlList: Shop.ShopLogoUrlList,
            ShopLogoUrl: shopimg,
            ContractAddress: Shop.ContractAddress,
            Distance: Shop.Distance === -1 ? '' : distanceDisplay(Shop.Distance),
            DataRangeSysNo: Shop.DataRangeSysNo
        };
      }
    }
  };